import {
   BeneficiariesIcon,
   MembersIcon,
   PaymentPlanIcon,
   WorkspacesIcon,
   ProfileInformationIcon,
   SubscriptionPlanIcon,
   LoginInformationIcon,
   DeleteIcon,
   TicketsIcon,
   TeamIcon,
   UsageIcon,
   FundsIcon,
   AutomatedCampaignsIcon,
   ProjectDashboardIcon,
   SurveysIcon,
   AssignmentsIcon,
   SurveyAnalyticsIcon
} from "../_metronic/layout/components/aside/aside-menu/components/SidebarIcons";
import { UserRolesEnum } from "./pages/auth/userRoles.enum";
import { isBusinessAccount } from "./base/services/accountLevel.service";

// `business: true` marks the entries a business account keeps — its
// workspaces, a project's dashboard, surveys, automated campaigns, survey
// analytics and the account settings. The rest are an organization's tools; see
// base/services/accountLevel.service.js.
export const filterMenuByAccountLevel = (items) =>
   isBusinessAccount() ? (items ?? []).filter((item) => item.business) : items;

export const menu = {
   layout: [
      {
         id: "project-dashboard",
         business: true,
         title: "Project Dashboard",
         type: "module",
         logic: "enteredProject",
         icon: ProjectDashboardIcon,
         url: "/dashboard",
         role: [
            UserRolesEnum.SuperAdmin,
            UserRolesEnum.Organization,
            UserRolesEnum.JuniorProjectManager,
            UserRolesEnum.AdminOfOrganization,
            UserRolesEnum.SeniorProjectManager,
            UserRolesEnum.ProjectManager,
            UserRolesEnum.Guest
         ]
      },
      {
         id: "menu-workspace-list-admin",
         title: "Workspaces",
         type: "module",
         logic: null,
         icon: "flaticon2-talk",
         url: "/workspace",
         role: [
            UserRolesEnum.SuperAdmin,
            UserRolesEnum.Organization,
            UserRolesEnum.AdminOfOrganization
         ]
      },
      {
         id: "menu-user-management-admin",
         title: "User management",
         type: "module",
         logic: null,
         icon: MembersIcon,
         url: "/user-management",
         role: [
            UserRolesEnum.SuperAdmin,
            UserRolesEnum.Organization,
            UserRolesEnum.AdminOfOrganization
         ]
      },
      {
         id: "menu-payment-plans-admin",
         title: "Payment plans",
         type: "module",
         logic: null,
         icon: PaymentPlanIcon,
         url: "/payment-plans",
         role: [
            UserRolesEnum.SuperAdmin,
            UserRolesEnum.Organization,
            UserRolesEnum.AdminOfOrganization,
            UserRolesEnum.SeniorProjectManager
         ]
      },
      {
         id: "menu-calls-history",
         title: "Project Dashboard",
         type: "module",
         logic: null,
         icon: "flaticon2-talk",
         url: "/dashboard",
         role: [
            UserRolesEnum.SuperAdmin,
            UserRolesEnum.Organization,
            UserRolesEnum.JuniorProjectManager,
            UserRolesEnum.AdminOfOrganization,
            UserRolesEnum.SeniorProjectManager,
            UserRolesEnum.ProjectManager,
            UserRolesEnum.Guest
         ]
      },
      {
         id: "kapSurvey-divider-1",
         title: "Build",
         type: "divider",
         logic: "enteredProject",
         role: [
            UserRolesEnum.SuperAdmin,
            UserRolesEnum.Organization,
            UserRolesEnum.JuniorProjectManager,
            UserRolesEnum.AdminOfOrganization,
            UserRolesEnum.SeniorProjectManager,
            UserRolesEnum.ProjectManager
         ]
      },
      // {
      //    id: "menu-rleationships",
      //    title: "Relationships",
      //    type: "module",
      //    logic: "enteredProject",
      //    icon: RelationshipIcon,
      //    url: "/relationships",
      //    role: [
      //       UserRolesEnum.SuperAdmin,
      //       UserRolesEnum.Organization,
      //       UserRolesEnum.AdminOfOrganization,
      //       UserRolesEnum.SeniorProjectManager
      //    ]
      // },
      {
         id: "menu-beneficiaries",
         title: "Audience",
         type: "module",
         logic: "enteredProject",
         icon: BeneficiariesIcon,
         url: "/audience",
         role: [
            UserRolesEnum.SuperAdmin,
            UserRolesEnum.Organization,
            UserRolesEnum.JuniorProjectManager,
            UserRolesEnum.AdminOfOrganization,
            UserRolesEnum.SeniorProjectManager,
            UserRolesEnum.ProjectManager
         ]
      },
      {
         id: "menu-surveys",
         business: true,
         title: "Surveys",
         type: "module",
         logic: "enteredProject",
         icon: SurveysIcon,
         url: "/surveys",
         role: [
            UserRolesEnum.SuperAdmin,
            UserRolesEnum.Organization,
            UserRolesEnum.JuniorProjectManager,
            UserRolesEnum.AdminOfOrganization,
            UserRolesEnum.SeniorProjectManager,
            UserRolesEnum.ProjectManager,
            UserRolesEnum.Guest
         ]
      },
      // {
      //    id: "menu-targets",
      //    title: "Targets",
      //    type: "module",
      //    logic: "enteredProject",
      //    icon: TargetsIcon,
      //    url: "/targets",
      //    role: [
      //       UserRolesEnum.SuperAdmin,
      //       UserRolesEnum.Organization,
      //       UserRolesEnum.JuniorProjectManager,
      //       UserRolesEnum.AdminOfOrganization,
      //       UserRolesEnum.SeniorProjectManager,
      //       UserRolesEnum.ProjectManager
      //    ]
      // },
      {
         id: "kapSurvey-divider-6",
         title: "Distribute",
         type: "divider",
         logic: "enteredProject",
         role: [
            UserRolesEnum.SuperAdmin,
            UserRolesEnum.Organization,
            UserRolesEnum.JuniorProjectManager,
            UserRolesEnum.AdminOfOrganization,
            UserRolesEnum.SeniorProjectManager,
            UserRolesEnum.ProjectManager
         ]
      },
      {
         id: "menu-automated-campaigns",
         business: true,
         title: "Automated Campaigns",
         type: "module",
         logic: "enteredProject",
         icon: AutomatedCampaignsIcon,
         url: "/automated-campaigns",
         role: [
            UserRolesEnum.SuperAdmin,
            UserRolesEnum.Organization,
            UserRolesEnum.JuniorProjectManager,
            UserRolesEnum.AdminOfOrganization,
            UserRolesEnum.SeniorProjectManager,
            UserRolesEnum.ProjectManager
         ]
      },
      {
         id: "menu-task-management",
         title: "Assignments",
         type: "module",
         logic: "enteredProject",
         icon: AssignmentsIcon,
         url: "/assignments",
         role: [
            UserRolesEnum.SuperAdmin,
            UserRolesEnum.Organization,
            UserRolesEnum.JuniorProjectManager,
            UserRolesEnum.AdminOfOrganization,
            UserRolesEnum.SeniorProjectManager,
            UserRolesEnum.ProjectManager
         ]
      },
      {
         id: "kapSurvey-divider-8",
         title: "Analyze",
         type: "divider",
         logic: "enteredProject",
         role: [
            UserRolesEnum.SuperAdmin,
            UserRolesEnum.Organization,
            UserRolesEnum.JuniorProjectManager,
            UserRolesEnum.AdminOfOrganization,
            UserRolesEnum.SeniorProjectManager,
            UserRolesEnum.ProjectManager,
            UserRolesEnum.Guest
         ]
      },
      {
         id: "menu-survey-analytics",
         business: true,
         title: "Survey Analytics",
         type: "module",
         logic: "enteredProject",
         icon: SurveyAnalyticsIcon,
         url: "/survey-analytics/",
         role: [
            UserRolesEnum.SuperAdmin,
            UserRolesEnum.Organization,
            UserRolesEnum.JuniorProjectManager,
            UserRolesEnum.AdminOfOrganization,
            UserRolesEnum.SeniorProjectManager,
            UserRolesEnum.ProjectManager,
            UserRolesEnum.Guest
         ]
      },
      // {
      //    id: "kapSurvey-divider-2",
      //    title: "Manage Surveys",
      //    type: "divider",
      //    logic: "enteredProject",
      //    role: [
      //       UserRolesEnum.SuperAdmin,
      //       UserRolesEnum.Organization,
      //       UserRolesEnum.JuniorProjectManager,
      //       UserRolesEnum.AdminOfOrganization,
      //       UserRolesEnum.SeniorProjectManager,
      //       UserRolesEnum.ProjectManager,
      //       UserRolesEnum.Guest
      //    ]
      // },
      // {
      //    id: "menu-survey-tools",
      //    title: "Build",
      //    type: "module",
      //    logic: "enteredProject",
      //    icon: SurveyTools1Icon,
      //    url: "/survey/survey-tools",
      //    role: [
      //       UserRolesEnum.SuperAdmin,
      //       UserRolesEnum.Organization,
      //       UserRolesEnum.JuniorProjectManager,
      //       UserRolesEnum.AdminOfOrganization,
      //       UserRolesEnum.SeniorProjectManager,
      //       UserRolesEnum.ProjectManager,
      //       UserRolesEnum.Guest
      //    ]
      // },
      // {
      //    id: "menu-survey-data1",
      //    title: "Results & Analytics",
      //    type: "module",
      //    logic: "enteredProject",
      //    icon: SurveyData1Icon,
      //    url: "/survey/survey-data",
      //    role: [
      //       UserRolesEnum.SuperAdmin,
      //       UserRolesEnum.Organization,
      //       UserRolesEnum.JuniorProjectManager,
      //       UserRolesEnum.AdminOfOrganization,
      //       UserRolesEnum.SeniorProjectManager,
      //       UserRolesEnum.ProjectManager,
      //       UserRolesEnum.Guest
      //    ]
      // },
      {
         id: "kapSurvey-divider-55",
         title: "Project Settings",
         type: "divider",
         logic: "enteredProject",
         role: [
            UserRolesEnum.SuperAdmin,
            UserRolesEnum.Organization,
            UserRolesEnum.JuniorProjectManager,
            UserRolesEnum.AdminOfOrganization,
            UserRolesEnum.SeniorProjectManager,
            UserRolesEnum.ProjectManager
         ]
      },
      // {
      //    id: "menu-tasks",
      //    title: "Tasks",
      //    type: "module",
      //    logic: "enteredProject",
      //    icon: "flaticon2-setup",
      //    url: "/tasks",
      //    role: [
      //       UserRolesEnum.SuperAdmin,
      //       UserRolesEnum.Organization,
      //       UserRolesEnum.JuniorProjectManager,
      //       UserRolesEnum.AdminOfOrganization,
      //       UserRolesEnum.SeniorProjectManager,
      //       UserRolesEnum.DataCollector
      //    ]
      // },
      {
         id: "menu-members",
         title: "Team",
         type: "module",
         logic: "enteredProject",
         icon: MembersIcon,
         // url: "/members",
         url: "/team",
         role: [
            UserRolesEnum.SuperAdmin,
            UserRolesEnum.Organization,
            UserRolesEnum.JuniorProjectManager,
            UserRolesEnum.AdminOfOrganization,
            UserRolesEnum.SeniorProjectManager,
            UserRolesEnum.ProjectManager
         ]
      },
      {
         id: "deleted-items",
         title: "Deleted items",
         type: "module",
         logic: "enteredProject",
         icon: DeleteIcon,
         url: `/deleted-items`,
         role: [
            UserRolesEnum.SuperAdmin,
            UserRolesEnum.Organization,
            UserRolesEnum.AdminOfOrganization,
            UserRolesEnum.SeniorProjectManager,
            UserRolesEnum.ProjectManager
         ]
      }
      // {
      //    id: "menu-survey-quick-actions",
      //    title: "Quick Actions",
      //    type: "module",
      //    logic: "enteredProject",
      //    icon: "flaticon2-setup",
      //    url: "/quick-actions",
      //    role: [
      //       UserRolesEnum.SuperAdmin,
      //       UserRolesEnum.Organization,
      //       UserRolesEnum.JuniorProjectManager,
      //       UserRolesEnum.AdminOfOrganization,
      //       UserRolesEnum.SeniorProjectManager
      //    ]
      // }
      // {
      //    id: "menu-Surveys",
      //    title: "Surveys",
      //    type: "module",
      //    icon: "flaticon2-list-1",
      //    url: "/survey",
      //    role: [UserRolesEnum.SuperAdmin],
      //    subMenus: [
      //       {
      //          id: "menu-survey-import",
      //          title: "Import",
      //          type: "item",
      //          icon: "flaticon2-user",
      //          url: "/survey/import",
      //          role: [UserRolesEnum.SuperAdmin, UserRolesEnum.Manager]
      //       },
      //       {
      //          id: "menu-survey-new",
      //          title: "New Survey",
      //          type: "item",
      //          icon: "flaticon2-user",
      //          url: "/survey/new",
      //          role: [UserRolesEnum.SuperAdmin, UserRolesEnum.Manager]
      //       }
      //    ]
      // },
      // {
      //    id: "menu-members",
      //    title: "Members",
      //    type: "module",
      //    icon: "flaticon2-avatar",
      //    url: "/members",
      //    role: [UserRolesEnum.SuperAdmin],
      //    subMenus: [
      //       {
      //          id: "members-list",
      //          title: "Members List",
      //          type: "item",
      //          icon: "flaticon2-user",
      //          url: "/members/list",
      //          role: [UserRolesEnum.SuperAdmin, UserRolesEnum.Manager]
      //       },
      //       {
      //          id: "members-adf",
      //          title: "Add Member",
      //          type: "item",
      //          icon: "flaticon2-user",
      //          url: "/members/new",
      //          role: [UserRolesEnum.SuperAdmin, UserRolesEnum.Manager]
      //       },
      //       {
      //          id: "role-add",
      //          title: "Add Role",
      //          type: "item",
      //          icon: "flaticon2-user",
      //          url: "/members/role/add",
      //          role: [UserRolesEnum.SuperAdmin, UserRolesEnum.Manager]
      //       }
      //    ]
      // }
   ],
   adminLayout: [
      {
         id: "kapSurvey-divider-2",
         business: true,
         title: "Admin management",
         type: "divider",
         logic: "enteredProject",
         role: [
            UserRolesEnum.SuperAdmin,
            UserRolesEnum.Organization,
            UserRolesEnum.AdminOfOrganization,
            UserRolesEnum.SeniorProjectManager
         ]
      },
      {
         id: "menu-survey-tools",
         business: true,
         title: "Workspaces",
         type: "module",
         logic: "enteredProject",
         icon: WorkspacesIcon,
         url: "/admin-workspaces",
         role: [
            UserRolesEnum.SuperAdmin,
            UserRolesEnum.Organization,
            UserRolesEnum.AdminOfOrganization,
            UserRolesEnum.SeniorProjectManager
         ]
      },
      {
         id: "admin-deleted-items",
         business: true,
         title: "Deleted items",
         type: "module",
         logic: "enteredProject",
         icon: DeleteIcon,
         url: `/admin-deleted-items`,
         role: [
            UserRolesEnum.SuperAdmin,
            UserRolesEnum.Organization,
            UserRolesEnum.AdminOfOrganization,
            UserRolesEnum.SeniorProjectManager
         ]
      },
      {
         id: "kapSurvey-divider-3",
         business: true,
         title: "Account settings",
         type: "divider",
         logic: "enteredProject",
         role: [
            UserRolesEnum.SuperAdmin,
            UserRolesEnum.Organization,
            UserRolesEnum.JuniorProjectManager,
            UserRolesEnum.AdminOfOrganization,
            UserRolesEnum.SeniorProjectManager,
            UserRolesEnum.ProjectManager,
            UserRolesEnum.Guest
         ]
      },
      {
         id: "menu-survey-data5",
         business: true,
         title: "Profile",
         type: "module",
         logic: "enteredProject",
         icon: ProfileInformationIcon,
         url: "/profile",
         role: [
            UserRolesEnum.SuperAdmin,
            UserRolesEnum.Organization,
            UserRolesEnum.AdminOfOrganization,
            UserRolesEnum.SeniorProjectManager,
            UserRolesEnum.JuniorProjectManager,
            UserRolesEnum.ProjectManager
            // UserRolesEnum.Guest
         ]
      },
      {
         id: "menu-survey-data7",
         business: true,
         title: "Login & Security",
         type: "module",
         logic: "enteredProject",
         icon: LoginInformationIcon,
         url: "/login-information",
         role: [
            UserRolesEnum.SuperAdmin,
            UserRolesEnum.Organization,
            UserRolesEnum.AdminOfOrganization,
            UserRolesEnum.SeniorProjectManager,
            UserRolesEnum.JuniorProjectManager,
            UserRolesEnum.ProjectManager
            // UserRolesEnum.Guest
         ]
      },
      {
         id: "menu-survey-data2",
         title: "Team",
         type: "module",
         logic: "enteredProject",
         icon: TeamIcon,
         url: "/admin-user-management",
         role: [
            UserRolesEnum.SuperAdmin,
            UserRolesEnum.Organization,
            UserRolesEnum.AdminOfOrganization,
            UserRolesEnum.SeniorProjectManager
         ]
      },
      {
         id: "kapSurvey-divider-5",
         business: true,
         title: "Billing",
         type: "divider",
         logic: "enteredProject",
         role: [UserRolesEnum.Organization],
         // Also shown to whoever may manage billing (AdminAsideMenuList.js).
         billing: true
      },
      {
         id: "menu-survey-data8",
         business: true,
         title: "Subscription",
         type: "module",
         logic: "enteredProject",
         icon: SubscriptionPlanIcon,
         url: "/subscription-plans",
         // Shown by canManageBilling, not by role (AdminAsideMenuList.js).
         billing: true
      },
      {
         id: "menu-survey-data4",
         business: true,
         title: "Usage",
         type: "module",
         logic: "enteredProject",
         icon: UsageIcon,
         url: "/usage",
         role: [UserRolesEnum.Organization]
      },
      {
         id: "menu-survey-data3",
         business: true,
         title: "Balance",
         type: "module",
         logic: "enteredProject",
         icon: FundsIcon,
         url: "/balance",
         role: [UserRolesEnum.Organization]
      },
      {
         id: "kapSurvey-divider-4",
         business: true,
         title: "Help center",
         type: "divider",
         logic: "enteredProject",
         role: [
            UserRolesEnum.SuperAdmin,
            UserRolesEnum.Organization,
            UserRolesEnum.JuniorProjectManager,
            UserRolesEnum.AdminOfOrganization,
            UserRolesEnum.SeniorProjectManager,
            UserRolesEnum.ProjectManager,
            UserRolesEnum.Guest
         ]
      },
      {
         id: "menu-survey-data9",
         business: true,
         title: "Tickets",
         type: "module",
         logic: "enteredProject",
         icon: TicketsIcon,
         url: "/tickets",
         role: [
            UserRolesEnum.SuperAdmin,
            UserRolesEnum.Organization,
            UserRolesEnum.AdminOfOrganization,
            UserRolesEnum.SeniorProjectManager,
            UserRolesEnum.JuniorProjectManager,
            UserRolesEnum.ProjectManager,
            UserRolesEnum.Guest
         ]
      }
   ]
};
